
import CollectorDetailInfo from "./CollectorDetailInfo";
import CollectorContactForm from "./CollectorContact";
import Configuration from "./CollectorsConfiguration";
import CollectorNotesForm from "./CollectorNotes";
import CollectorDocumentsForm from "./CollectorDocuments";
import CollectorHistoryForm from "./CollectorHistory";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const CollectorDetailsForm = () => {
    return (
        <>
            <div className="md:grid grid-cols-9 gap-4 mt-3">

                <div className="col-span-5 space-y-4">
                    <CollectorDetailInfo isReadOnly={hasPermission(["COLL-U"]) === false} />
                    <CollectorContactForm />

                    <Configuration />
                </div>
                <div className="col-span-4">
                    {hasPermission(["COLNOT-R"]) && <CollectorNotesForm />}
                    {hasPermission(["COLFIL-R"]) && <CollectorDocumentsForm />}
                    {hasPermission(["COLLOG-R"]) && <CollectorHistoryForm />}
                </div>
            </div>
        </>
    );
};

export default CollectorDetailsForm;